// extracted by mini-css-extract-plugin
export var colorSquare = "_s0-0";
export var danger = "_s0-5";
export var lightPink = "_s0-8";
export var neutralBlue = "_s0-7";
export var neutralYellow = "_s0-6";
export var normal = "_s0-1";
export var primary = "_s0-2";
export var primaryLight = "_s0-3";
export var solidBlack = "_s0-g";
export var solidGreen = "_s0-b";
export var solidLightBlue = "_s0-d";
export var solidNavy = "_s0-c";
export var solidOrange = "_s0-f";
export var solidPink = "_s0-e";
export var solidRed = "_s0-9";
export var solidYellow = "_s0-a";
export var success = "_s0-4";